import { IconButton, Tooltip } from "@mui/material";
import { ArrowForward, FileOpen } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { fetchDocumentUrlAndOpenDialog } from "../../services/sharepoint.service";

// Row shape used by the Reference "Experts" tab EditableDataGrid (see ExpertLinkRow in
// ReferenceForm.tsx / LinkedExpertType in dataTypes.ts). Only the fields this cell needs.
type ReferenceExpertActionsCellRow = {
  id: number; // expertID
  cvlink?: string | null;
};

type ReferenceExpertActionsCellProps = {
  row: ReferenceExpertActionsCellRow;
};

// Mirrors ExpertsTable.tsx's own "View Details" / "View Latest CV" row actions, but for a
// single expert row on a reference's Experts tab: link straight to that expert's own
// detail page (/experts/:expertID) and open their latest CV directly.
function ReferenceExpertActionsCell({ row }: ReferenceExpertActionsCellProps) {
  const navigate = useNavigate();
  // Same source as ExpertsTable.tsx - the MSAL access token is stashed in localStorage
  // after login rather than threaded down through props here.
  const accessToken = localStorage.getItem('accessToken') || '';

  return (
    <>
      <Tooltip title="View Expert Details">
        <IconButton size="small" onClick={() => navigate(`/experts/${row.id}`)}>
          <ArrowForward fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title={row.cvlink ? "View Latest CV" : "No CV on file"}>
        <span>
          <IconButton
            size="small"
            disabled={!row.cvlink}
            onClick={() => row.cvlink && fetchDocumentUrlAndOpenDialog(row.cvlink, accessToken)}
          >
            <FileOpen fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </>
  );
}

export default ReferenceExpertActionsCell;
